import React from "react";
import {
  Box,
  Typography,
  Paper,
  Avatar,
  Divider,
  Container,
  useMediaQuery,
  useTheme,
  Card,
} from "@mui/material";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";

const FounderMessage = ({ isDarkTheme = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  // Primary colors for the component
  const primaryColor = "#228B22"; // Forest Green to match the site's theme
  const bgColor = isDarkTheme ? "#1a2c1a" : "#f5f9f5";
  const textColor = isDarkTheme ? "#e0e0e0" : "#333333";
  const accentColor = isDarkTheme ? "#4caf50" : "#1e7a1e";

  return (
    <Container maxWidth="lg" sx={{ my: 5 }}>
      <Card
        elevation={5}
        sx={{
          bgcolor: bgColor,
          borderRadius: 4,
          overflow: "hidden",
          position: "relative",
          boxShadow: "0 8px 32px rgba(34, 139, 34, 0.12)",
        }}
      >
        {/* Decorative elements */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            opacity: 0.05,
            background:
              "radial-gradient(circle at top right, #4CAF50, transparent 70%), " +
              "radial-gradient(circle at bottom left, #8BC34A, transparent 70%)",
          }}
        />

        {/* Content container */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            position: "relative",
            zIndex: 1,
            p: { xs: 3, md: 4 },
          }}
        >
          {/* Message section */}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box sx={{ position: "relative" }}>
              <FormatQuoteIcon
                sx={{
                  position: "absolute",
                  fontSize: "4rem",
                  opacity: 0.1,
                  color: accentColor,
                  top: -20,
                  left: -15,
                  transform: "rotate(180deg)",
                }}
              />
              
              <Typography
                variant="h5"
                component="h2"
                gutterBottom
                sx={{
                  fontWeight: 700,
                  color: accentColor,
                  mt: 2,
                }}
              >
                A Message from the Founder
              </Typography>
              
              <Typography
                variant="body1"
                paragraph
                sx={{
                  color: textColor,
                  lineHeight: 1.8,
                  fontSize: "1rem",
                  mt: 2,
                }}
              >
                I'm excited to introduce this tool as a way to support you in managing your time more effectively and making your workday smoother.
              </Typography>
              
              <Typography
                variant="body1"
                paragraph
                sx={{
                  color: textColor,
                  lineHeight: 1.8,
                  fontSize: "1rem",
                }}
              >
                It's designed to help you focus better, reduce manual tasks, and bring more clarity to your day — so you can complete your work with less stress and more ease.
              </Typography>
              
              <Typography
                variant="body1"
                paragraph
                sx={{
                  color: textColor,
                  lineHeight: 1.8,
                  fontSize: "1rem",
                }}
              >
                The real goal is to help you finish your day efficiently, leaving more time for the things you love — whether it's spending time with family, hitting the gym, enjoying a hobby, or simply relaxing.
              </Typography>
              
              <Typography
                variant="body1"
                paragraph
                sx={{
                  color: textColor,
                  lineHeight: 1.8,
                  fontSize: "1rem",
                }}
              >
                Let's use this tool to work smarter, stay organized, and create space for a balanced life.
              </Typography>
              
              <Typography
                variant="body1"
                paragraph
                sx={{
                  color: textColor,
                  lineHeight: 1.8,
                  fontSize: "1rem",
                }}
              >
                Thank you for your amazing energy and commitment.
              </Typography>
              <FormatQuoteIcon
                sx={{
                  position: "absolute",
                  fontSize: "4rem",
                  opacity: 0.1,
                  color: accentColor,
                  bottom: -40,
                  right: -15,
                }}
              />
            </Box>
          </Box>
        </Box>
      </Card>
    </Container>
  );
};

export default FounderMessage;